import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from './../../environments/environment';
import { Usuario } from "./../models/t1_usuario.model";
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  public login_user: Usuario = new Usuario();

  constructor(private router:Router, private http:HttpClient) { }

  logout(){
    this.removeToken();
    window.location.href = '/login';
  }

  getToken(){
    return <string>localStorage.getItem('access_token');
  }

  removeToken(){
    localStorage.removeItem('id_token');
    localStorage.removeItem('access_token');
  }


  // Método para iniciar login con Office 365
  initiateOffice365Login(): Observable<any> {
    return this.http.get<any>(environment.apiUrl + '/auth/office365');
  }

  // Método para redirigir a Office 365
  redirectToOffice365(): void {
    this.initiateOffice365Login().subscribe({
      next: (response) => {
        if (response.authUrl) {
          window.location.href = response.authUrl;
        }
      },
      error: (error) => {
        console.error('Error iniciando autenticación Office 365:', error);
        alert('Error al conectar con Office 365');
      }
    });
  }

  // Método para manejar el callback de Office 365
  handleOffice365Callback(token: string): void {
    if (token) {
      localStorage.setItem('access_token', token);
      this.router.navigate(['/admin']);
    } else {
      this.router.navigate(['/login'], { 
        queryParams: { error: 'token_missing' } 
      });
    }
  }




  validarLoginPromise(){
    return new Promise<any>( (resultado) => {
      this.validarLogin().subscribe(
        res => {
          console.log(res);
          if(res?.t1_id){
            this.login_user = res;
          }else{
            resultado({});
          }
          resultado(res);
        },
        err => {
          resultado({});
        }
      )
    });
  }

  validarLogin(){
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${this.getToken()}`
    });
    return this.http.post<any>(environment.apiUrl+'/token',{},{headers: headers});
  }


}
